<template>
    <div :id="`c${id}`" class="carousel slide carousel-fade m-3" data-bs-ride="carousel">
        <div class="carousel-inner">
            <slot />
        </div>
        <button class="carousel-control-prev" type="button" :data-bs-target="`#c${id}`" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" :data-bs-target="`#c${id}`" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'CarouselContainer',
    props: {
      id: String,
    }
}
</script>

<style lang="scss" scoped>

</style>